import { render } from "./BottomPanel.vue?vue&type=template&id=5daa445f"
import script from "./BottomPanel.vue?vue&type=script&lang=js"
export * from "./BottomPanel.vue?vue&type=script&lang=js"

import "./BottomPanel.vue?vue&type=style&index=0&id=5daa445f&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__